import script from "./CashierPain.vue?vue&type=script&setup=true&lang=js"
export * from "./CashierPain.vue?vue&type=script&setup=true&lang=js"

import "./CashierPain.vue?vue&type=style&index=0&id=059cbfbe&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059cbfbe"]])

export default __exports__